/**
 * Console Easter Egg - For the curious developers out there!
 */

const consoleEasterEgg = () => {
  // Check if console is available
  if (typeof window === 'undefined' || !window.console) {
    return;
  }

  // ASCII Art Banner
  const banner = `
   ██████╗ ██╗    ██╗ █████╗ ██╗███╗   ██╗
   ██╔══██╗██║    ██║██╔══██╗██║████╗  ██║
   ██║  ██║██║ █╗ ██║███████║██║██╔██╗ ██║
   ██║  ██║██║███╗██║██╔══██║██║██║╚██╗██║
   ██████╔╝╚███╔███╔╝██║  ██║██║██║ ╚████║
   ╚═════╝  ╚══╝╚══╝ ╚═╝  ╚═╝╚═╝╚═╝  ╚═══╝
  `;

  // Styles for different console messages
  const styles = {
    banner: 'color: #00ff00; font-weight: bold; font-family: monospace; font-size: 12px;',
    welcome: 'color: #00d4ff; font-size: 16px; font-weight: bold;',
    info: 'color: #ffae00; font-size: 14px;',
    command: 'color: #ff6b6b; font-size: 12px; font-family: monospace; background: #1a1a1a; padding: 4px 8px; border-radius: 4px;',
    secret: 'color: #9d4edd; font-size: 13px; font-style: italic;',
    link: 'color: #06ffa5; font-size: 12px; text-decoration: underline;',
  };

  // Clear console and show banner
  console.clear();
  console.log('%c' + banner, styles.banner);

  console.log(
    '%c🚀 Welcome to Developer Mode!',
    styles.welcome
  );

  console.log(
    '%c⚡ You\'re curious, I like that!\n',
    styles.info
  );

  console.log(
    '%c💡 Available Commands:\n',
    styles.info
  );

  console.log('%cdwain.info()', styles.command);
  console.log('  → Display system info\n');

  console.log('%cdwain.skills()', styles.command);
  console.log('  → Show tech skills\n');

  console.log('%cdwain.easteregg()', styles.command);
  console.log('  → More hidden surprises\n');

  console.log('%cdwain.matrix()', styles.command);
  console.log('  → Follow the white rabbit...\n');

  console.log(
    '%c💎 Psst... Did you find the README.md in the Explorer?',
    styles.secret
  );

  // Create global dwain object with commands
  (window as any).dwain = {
    info: () => {
      console.log(
        '%c\n' +
        '═══════════════════════════════════════\n' +
        '  📊 SYSTEM INFO\n' +
        '═══════════════════════════════════════\n' +
        '  Framework: React + TypeScript\n' +
        '  Styling: SASS/SCSS\n' +
        '  Routing: React Router v6\n' +
        '  i18n: react-i18next\n' +
        '  Icons: React Icons\n' +
        '═══════════════════════════════════════\n',
        'color: #00d4ff; font-family: monospace;'
      );
    },

    skills: () => {
      const skills = [
        { name: 'React', level: '████████░░', percentage: 85 },
        { name: 'TypeScript', level: '███████░░░', percentage: 75 },
        { name: 'Node.js', level: '████████░░', percentage: 80 },
        { name: 'SASS/CSS', level: '████████░░', percentage: 85 },
        { name: 'Git', level: '███████░░░', percentage: 75 },
      ];

      console.log(
        '%c\n' +
        '═══════════════════════════════════════\n' +
        '  🛠️  TECH SKILLS\n' +
        '═══════════════════════════════════════',
        'color: #ffd700; font-family: monospace; font-weight: bold;'
      );

      skills.forEach(skill => {
        console.log(
          `%c  ${skill.name.padEnd(15)} ${skill.level} ${skill.percentage}%`,
          'color: #06ffa5; font-family: monospace;'
        );
      });

      console.log(
        '%c═══════════════════════════════════════\n',
        'color: #ffd700; font-family: monospace;'
      );
    },

    easteregg: () => {
      const secrets = [
        '🎮 Konami Code activated!',
        '🔥 You found a secret!',
        '🦄 Unicorns are real!',
        '🌟 The cake is a lie!',
        '🎯 Achievement unlocked: Curious Developer',
        '🚀 To infinity and beyond!',
        '💎 This is a hidden gem!',
        '🎪 Welcome to the circus!',
        '🧙‍♂️ You\'re a wizard, Harry!',
        '🎨 Art is an explosion!',
      ];

      const randomSecret = secrets[Math.floor(Math.random() * secrets.length)];

      console.log(
        `%c\n${randomSecret}\n`,
        'color: #ff6b6b; font-size: 20px; font-weight: bold; text-shadow: 2px 2px 4px rgba(0,0,0,0.5);'
      );

      console.log(
        '%c🎁 Here\'s a gift for you:\n   console.table() is your friend!',
        'color: #9d4edd; font-style: italic;'
      );
    },

    matrix: () => {
      const chars = '01アイウエオカキクケコサシスセソタチツテトナニヌネノ';
      let output = '\n';

      for (let i = 0; i < 10; i++) {
        for (let j = 0; j < 50; j++) {
          output += chars[Math.floor(Math.random() * chars.length)];
        }
        output += '\n';
      }

      console.log(
        '%c' + output,
        'color: #00ff00; font-family: monospace; font-size: 10px; line-height: 1.2;'
      );

      console.log(
        '%cWake up, Neo... The Matrix has you...',
        'color: #00ff00; font-size: 14px; font-style: italic; animation: blink 1s infinite;'
      );
    },

    // Hidden command - shows all available commands
    help: () => {
      console.log(
        '%c\n' +
        '╔════════════════════════════════════════╗\n' +
        '║  🎯 AVAILABLE COMMANDS                ║\n' +
        '╔════════════════════════════════════════╗\n' +
        '║  dwain.info()       - System Info     ║\n' +
        '║  dwain.skills()     - Tech Skills     ║\n' +
        '║  dwain.easteregg()  - Random Secret   ║\n' +
        '║  dwain.matrix()     - Follow Rabbit   ║\n' +
        '║  dwain.help()       - This Help       ║\n' +
        '╚════════════════════════════════════════╝\n',
        'color: #00d4ff; font-family: monospace;'
      );
    }
  };
};

export default consoleEasterEgg;
